import React, {Component, PropTypes} from 'react';
import i18next from 'i18next';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import {isMobile, toPX} from 'utils';
import Transition from 'components/utils/transition';

export class AutoscrollButton extends Component {
    static propTypes = {
        visible: PropTypes.bool.isRequired,
        scrollbarWidth: PropTypes.number.isRequired,
        rtl: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
    };

    state = {
        minimized: false,
        hover: false,
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.visible !== this.props.visible) {
            clearTimeout(this.minimizeTimeoutId);

            if (!nextProps.visible) {
                this.minimize();
            } else {
                this.maximize();
                this.minimizeTimeoutId = setTimeout(this.minimize, isMobile() ? 5000 : 3000); // Setup autohide
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.visible !== this.props.visible
            || nextProps.scrollbarWidth !== this.props.scrollbarWidth
            || nextProps.rtl !== this.props.rtl
            || nextProps.onClick !== this.props.onClick
            || nextState.hover !== this.state.hover
            || nextState.minimized !== this.state.minimized;
    }

    @autobind
    minimize() {
        this.setState({minimized: true});
    }

    @autobind
    maximize() {
        this.setState({minimized: false});
    }

    @autobind
    handleMouseEnter() {
        this.setState({hover: true});
    }

    @autobind
    handleMouseLeave() {
        this.setState({hover: false});
    }

    @autobind
    handleClick() {
        this.props.onClick();
    }

    @autobind
    handleTouchStart(event) {
        event.preventDefault();
        this.props.onClick();
    }

    render() {
        return (
            <Transition
                name={`resume-autoscroll${this.props.rtl ? '-rtl' : ''}`}
                className='cielo24-vwrap-resume-autoscroll-container'
                style={{[this.props.rtl ? 'marginLeft' : 'marginRight']: toPX(this.props.scrollbarWidth)}}
            >
                {this.props.visible && (
                    <button
                        type='button'
                        onMouseEnter={this.handleMouseEnter}
                        onMouseLeave={this.handleMouseLeave}
                        onTouchStart={this.handleTouchStart}
                        onFocus={this.handleMouseEnter}
                        onBlur={this.handleMouseLeave}
                        onClick={this.handleClick}
                    >
                        <span
                            className={classNames('cielo24-vwrap-resume-autoscroll', {
                                'cielo24-vwrap-minimized': this.state.minimized,
                                'cielo24-vwrap-hover': this.state.hover,
                                'cielo24-vwrap-rtl': this.props.rtl,
                            })}
                        >
                            <i className='cielo24-vwrap-icon cielo24-vwrap-icon-autoscroll' aria-hidden={true} />
                            {i18next.t('Resume autoscroll')}
                        </span>
                    </button>
                )}
            </Transition>
        );
    }
}

export default AutoscrollButton;



// WEBPACK FOOTER //
// ./scripts/components/transcript/autoscroll-button.js